import {
  CONSUMPTION_COST_TEXTS,
  CONSUMPTION_TABLE_TEXTS,
} from '../constants/consumptionsConstants';

const textSx = { textAlign: 'left' };
const numberSx = { textAlign: 'right' };

/**
 * Columnas de artículos consumidos; "Artículo" es la columna principal y toma el ancho restante.
 * @param {boolean} showCosts Si se muestran los costos originales.
 * @returns {Array<{key: string, label: string, sx: Object}>}
 */
export const buildConsumptionItemColumns = (showCosts) =>
  [
    { key: 'article', label: CONSUMPTION_TABLE_TEXTS.article, sx: textSx },
    { key: 'quantity', label: CONSUMPTION_TABLE_TEXTS.quantity, sx: { ...numberSx, width: 120 } },
    showCosts && {
      key: 'unitCost',
      label: CONSUMPTION_COST_TEXTS.unitCost,
      sx: { ...numberSx, width: 170 },
    },
    showCosts && {
      key: 'totalCost',
      label: CONSUMPTION_COST_TEXTS.totalCost,
      sx: { ...numberSx, width: 170 },
    },
    {
      key: 'reserved',
      label: CONSUMPTION_TABLE_TEXTS.reservedConsumed,
      sx: { ...numberSx, width: 150 },
    },
    { key: 'status', label: CONSUMPTION_TABLE_TEXTS.status, sx: { width: 120 } },
  ].filter(Boolean);
